<template>
  <div class="auth-wrapper d-flex no-block justify-content-center align-items-center">
    <div class="auth-box text-center">
      <img src="/logo-banner.png" class="auth-logo mb-4" alt="SocialLabs" />
      <div v-if="isLoading" class="py-5">
        <span class="spinner-border spinner" role="status"></span>
        <p class="mt-3 mb-0 text-muted">{{ $t('auth.google_signing_in') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

let activeGoogleTicket = null

export default {
  data() {
    return {
      isLoading: true,
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  async mounted() {
    const error = this.$route.query.error
    if (error) {
      this.$toast.error(this.errorMessage(error))
      await this.$router.replace('/login')
      return
    }

    const ticket = this.$route.query.ticket
    const redirect = this.$route.query.redirect || '/dashboard'

    if (!ticket) {
      if (this.isLoggedIn) {
        await this.$router.replace(redirect)
        return
      }
      this.$toast.error(this.$t('auth.google_sign_in_failed'))
      await this.$router.replace('/login')
      return
    }

    if (activeGoogleTicket === ticket) {
      if (this.isLoggedIn) {
        await this.$router.replace(redirect)
      }
      return
    }
    activeGoogleTicket = ticket

    try {
      await this.completeGoogle({ ticket })
      await this.$router.replace(redirect)
    } catch (err) {
      if (this.isLoggedIn) {
        await this.$router.replace(redirect)
        return
      }
      this.$toast.error(err.response?.data?.message || this.$t('auth.google_sign_in_failed'))
      await this.$router.replace('/login')
    } finally {
      if (activeGoogleTicket === ticket) {
        activeGoogleTicket = null
      }
    }
  },
  methods: {
    ...mapActions('auth', ['completeGoogle']),
    errorMessage(code) {
      const map = {
        access_denied: this.$t('auth.google_access_denied'),
        email_not_verified: this.$t('auth.google_email_not_verified'),
        inactive: this.$t('auth.google_inactive'),
        failed: this.$t('auth.google_sign_in_failed'),
      }
      return map[code] || this.$t('auth.google_sign_in_failed')
    },
  },
}
</script>

<style scoped>
.spinner { height: 1.5rem !important; width: 1.5rem !important; }
</style>
